import { BrandListerActionTypes } from '../../../enums/ActionEnums';
export const brandListerActions = {
    createSetFilterAction: (payload) => ({
        type: BrandListerActionTypes.SET_FILTER,
        payload,
    }),
};
